
import { defineComponent } from 'vue'
import '@/assets/style.css'

export default defineComponent({})
